module.exports = __webpack_public_path__ + "static/img/icon04.be69ad2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/culture/icon04.png
// module id = 2Sh6
// module chunks = 1